import { render, staticRenderFns } from "./PedidoCard.vue?vue&type=template&id=1f7f00c4&scoped=true"
import script from "./PedidoCard.vue?vue&type=script&lang=js"
export * from "./PedidoCard.vue?vue&type=script&lang=js"
import style0 from "./PedidoCard.vue?vue&type=style&index=0&id=1f7f00c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f00c4",
  null
  
)

export default component.exports